import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../data/content';

const CalloutContainer = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 500px;
  border-top: 2px solid #b7ab9f;
  border-bottom: 2px solid #b7ab9f;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    min-height: auto;
  }
`;

const CalloutContent = styled.div`
  background: #000000;
  padding: 80px 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;

  @media (max-width: 968px) {
    padding: 60px 40px;
    text-align: center;
    align-items: center;
  }

  @media (max-width: 568px) {
    padding: 40px 20px;
  }
`;

const CalloutImageSection = styled.div`
  background-image: url('/images/technology.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 500px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100px;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.4), transparent);
    z-index: 1;
  }

  @media (max-width: 968px) {
    min-height: 300px;
    order: -1;

    &::before {
      display: none;
    }
  }
`;

const CalloutTitle = styled.h2`
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: #ffffff;
  line-height: 1.3;
  max-width: 500px;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const CalloutHighlight = styled.span`
  color: #b7ab9f;
  font-weight: 700;
`;

const CalloutCTA = styled.button`
  background: #b7ab9f;
  color: #ffffff;
  border: 2px solid #b7ab9f;
  padding: 1rem 2.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    background: transparent;
    color: #b7ab9f;
  }
`;

const Callout = () => {
  const { language } = useLanguage();
  const t = content[language];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerHeight = 120; // Account for sticky header height
      const elementPosition = element.offsetTop - headerHeight;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <CalloutContainer id="callout">
      <CalloutContent>
        <CalloutTitle className="content-entry-animation">
          {t.callout.title}
        </CalloutTitle>
        <CalloutCTA className="content-entry-animation" onClick={scrollToContact}>
          {t.callout.cta}
        </CalloutCTA>
      </CalloutContent>
      <CalloutImageSection />
    </CalloutContainer>
  );
};

export default Callout; 
